// PrintInbois.js
// Reusable print preview for individual invoice (Inbois)
import { apiGetInboisDetailByNoInbois } from "../../api/inbois_detail";
import { apiSearchAkaun } from "../../api/akaun";
import QRCode from "qrcode";

export async function printInboisPreview(selected) {
  if (!selected) {
    throw new Error("Rekod inbois tidak dijumpai.");
  }
  // Fetch full invoice details
  const result = await apiGetInboisDetailByNoInbois(selected.no_inbois);
  const details = result.data || [];

  // Fetch akaun data for full alamat harta
  let akaunHarta = null;
  try {
    const akaunRes = await apiSearchAkaun({ no_akaun: selected.no_akaun }, 1, 1);
    akaunHarta = akaunRes.data && akaunRes.data.length > 0 ? akaunRes.data[0] : null;
  } catch (e) {
    // ignore, we can proceed without akaunHarta
  }

  // Compose customer address from akaun table (alamat harta)
  const customer = {
    name: selected.nama || akaunHarta?.nama || "",
    addressLines: [
      akaunHarta?.alamat1_harta || "",
      akaunHarta?.alamat2_harta || "",
      (akaunHarta?.poskod_harta || "") + (akaunHarta?.bandar_harta ? ` ${akaunHarta.bandar_harta}` : ""),
      akaunHarta?.negeri_harta || "",
    ].filter((line) => line && line !== "-"),
  };
  const meta = {
    kod_pelanggan: selected.kod_pelanggan || "",
    tarikh_inbois: selected.tarikh_inbois ? selected.tarikh_inbois.slice(0, 10) : "",
    no_inbois: selected.no_inbois || "",
  };
  // Calculate total
  const jumlah = details.reduce((sum, d) => sum + (parseFloat(d.jumlah) || 0), 0).toFixed(2);

  const printWindow = window.open("", "_blank");
  const printHtml = `
    <html>
    <head>
      <title>Inbois</title>
      <style>
        @page { size: A4; margin: 20mm 15mm 20mm 15mm; }
        html, body { width: 210mm; height: 297mm; }
        body { font-family: Arial, sans-serif; margin:0; padding:0; background:#fff; }
        .header { text-align:center; }
        .header-logo { float:left; margin-right:12px; }
        .header-title { font-weight:bold; font-size:16px; margin-top:8px; }
        .header-address { font-size:14px; margin-bottom:2px; margin-top:2px; }
        .inbois-title { font-size:20px; font-weight:600; margin: 16-px 0 8px 0; letter-spacing:2px; }
        .clearfix::after { content: ''; display: block; clear: both; }
        .rounded-box { border:1px solid #000; border-radius:12px; padding:10px 16px; margin-bottom:8px; min-height:60px; background:#fff; }
        .meta-box { float:right; font-size:13px; text-align:left; min-width:220px; }
        .meta-label { font-weight:600; display:inline-block; min-width:90px; }
        .jompay-box { border:1px solid #000; padding:1px 1px; margin-top:8px; background:#f8f8f8; display:flex; align-items:center; }
        .jompay-logo { height:28px; }
        .biller-info { font-size:11px; text-align:left; }
        .biller-label { font-size:11px; font-weight:600; text-align:left;}
        table { border-collapse:collapse; width:100%; margin-top:24px; }
        th, td { font-size:13px; }
        th { background:#f2f2f2; }
        .tfoot-label { border-top:1px solid #000; border-right:1px solid #000; border-bottom:none; border-left:none; padding:8px 4px; font-weight:bold; text-align:right; font-size:13px; }
        .tfoot-value { border-top:1px solid #000; border-right:1px solid #000; border-bottom:none; border-left:1px solid #000; padding:8px 4px; text-align:right; font-weight:bold; font-size:13px; }
        .footer-area { margin-top:60px; width:100%; display:flex; justify-content:space-between; align-items:flex-start; }
        .footer-left { text-align:left; font-size:14px; margin-top:24px; margin-left:18px; }
        .footer-right { text-align:right; margin-right:18px; }
        .pay-logos { display:flex; align-items:center; gap:8px; margin-top:4px; }
        .senangpay-logo { height:38px; border:1px solid #ccc; border-radius:6px; background:#fff; padding:2px 8px; }
        .card-logo { height:22px; }
        .qr-area { display:flex; align-items:center; gap:10px; margin-top:4px; }
        .qr-label { font-size:14px; margin-bottom:2px; font-size:14px; }
        .qr-img { height:80px; width:80px; border:1px solid #000; background:#fff; }
        .footer-note { width:100%; text-align:center; font-size:14px; margin-top:60px; font-style:italic; color:#222; }
      </style>
    </head>
    <body style="margin-left: 30px; margin-right: 30px; padding-left: 10px; padding-right: 10px;">
      <div class="header clearfix" style="display:flex; align-items:center; justify-content:flex-start; margin-bottom:8px;">
        <div style="flex:0 0 110px; display:flex; align-items:center; justify-content:center; height:100px;">
          <img src="/build/kejora.png" class="header-logo" style="height:130px; width:auto; display:block;" />
        </div>
        <div style="flex:1; display:flex; flex-direction:column; justify-content:center; align-items:flex-start; height:150px;">
          <div class="header-title" style="font-size:20px; font-weight:bold; margin-bottom:2px;">LEMBAGA KEMAJUAN JOHOR TENGGARA</div>
          <div class="header-address">Bangunan Ibu Pejabat KEJORA</div>
          <div class="header-address">Jalan Dato' Hj. Hassan Yunus,</div>
          <div class="header-address">81930 Bandar Penawar, Johor.</div>
          <div class="header-address">Telefon : 07-884 3000 &nbsp; Faks : 07-822 1600</div>
        </div>
      </div>
      <div class="inbois-title" style="text-align:center; font-size:25px; font-weight:600; margin: 30px 0 50px 0; letter-spacing:2px; width: 100%; ">INBOIS</div>
      <div style="display:flex; flex-direction:row; gap:15px; align-items:stretch; margin-bottom:8px;">
        <div class="rounded-box" style="width:55%; min-width:400px; flex:1;">
          <div style="font-weight:700; font-size:15px;">${customer.name}</div>
          ${customer.addressLines
            .map((line) => `<div style='margin-top:2px; font-size:15px;'>${line}</div>`)
            .join("")}
        </div>
        <div class="meta-box" style="flex:1; min-width:260px; gap:15px;">
          <div style="display:flex; flex-direction:row; align-items:center; margin-bottom:2.5px; margin-top:2.5px;">
            <span style="font-weight:700; min-width:110px; text-align:left; display:inline-block;" class="meta-label">Kod Pelanggan:</span>
            <span style="margin-left:8px;">${meta.kod_pelanggan}</span>
          </div>
          <div style="display:flex; flex-direction:row; align-items:center; margin-bottom:2.5px; margin-top:2.5px;">
            <span style="font-weight:700; min-width:110px; text-align:left; display:inline-block;" class="meta-label">Tarikh Invois:</span>
            <span style="margin-left:8px;">${meta.tarikh_inbois}</span>
          </div>
          <div style="display:flex; flex-direction:row; align-items:center; margin-bottom:2.5px; margin-top:2.5px;">
            <span style="font-weight:700; min-width:110px; text-align:left; display:inline-block;" class="meta-label">No Invois:</span>
            <span style="margin-left:8px;">${meta.no_inbois}</span>
          </div>
          <div style="display:flex; align-items:flex-start; gap:10px; margin-top:6px;">
            <img src="/build/jompay.png" class="jompay" style="height:50px; width:auto; display:block;" />
            <div class="jompay-box" style="height:50px; width:400px; float:none; margin:0; padding:1px 1px; border:2px solid #000; display:flex; flex-direction:column; justify-content:space-between; box-sizing:border-box; text-align:left;">
              <div style="width:100%; margin-left:5px;"><span style="font-weight:700;" class="biller-label">Biller Code: </span><span class="biller-info">89136</span></div>
              <div style="width:100%; margin-left:5px;"><span style="font-weight:700;" class="biller-label">Ref-1: </span><span class="biller-info">${meta.no_inbois}</span></div>
              <div style="width:100%; margin-left:5px;"><span style="font-weight:700;" class="biller-label">Ref-2: </span><span class="biller-info"></span></div>
            </div>
          </div>
          <div style="font-size:10px; color:#444; margin-top:2px;"><span style="font-weight:700; color:#000;">JomPAY</span> online di Perbankan Internet dan Telefon Mudah Alih dengan akaun semasa, simpanan atau kad kredit</div>
        </div>
      </div>
      <table style="border-collapse:collapse; width:100%; min-width:100%; max-width:100%; table-layout:fixed; margin-top:50px; height:400px;">
        <colgroup>
          <col style="width:40px;" />
          <col style="width:auto;" />
          <col style="width:120px;" />
        </colgroup>
        <thead>
          <tr>
            <th style="border:1px solid #000; padding:4px; font-weight:bold; text-align:center; height:35px;">BIL</th>
            <th style="border:1px solid #000; padding:4px; font-weight:bold; text-align:center;">BUTIRAN</th>
            <th style="border:1px solid #000; padding:4px; font-weight:bold; text-align:center;">JUMLAH (RM)</th>
          </tr>
        </thead>
        <tbody>
          ${(() => {
            const maxRows = 10;
            const renderedRows = [];
            const perkara = selected.perkara || "";
            const jumlahPerkara =
              selected.jumlah !== undefined && selected.jumlah !== null
                ? Number(selected.jumlah).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : "";
            const tunggakan =
              selected.tunggakan_to_date !== undefined && selected.tunggakan_to_date !== null
                ? Number(selected.tunggakan_to_date).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : "";
            const denda =
              selected.denda_to_date !== undefined && selected.denda_to_date !== null
                ? Number(selected.denda_to_date).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : "";

            renderedRows.push(`
              <tr>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px; text-align:center;">${
                  perkara ? 1 : ""
                }</td>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px;">${
                  perkara || ""
                }</td>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px; text-align:right;">${
                  perkara ? jumlahPerkara : ""
                }</td>
              </tr>
            `);
            renderedRows.push(`
              <tr>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px; text-align:center;">2</td>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px;">TUNGGAKAN</td>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px; text-align:right;">${tunggakan}</td>
              </tr>
            `);
            renderedRows.push(`
              <tr>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px; text-align:center;">3</td>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px;">DENDA</td>
                <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px; text-align:right;">${denda}</td>
              </tr>
            `);
            for (let i = 3; i < maxRows; i++) {
              renderedRows.push(`
                <tr>
                  <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px; text-align:center;"></td>
                  <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px;"></td>
                  <td style="border:1px solid #000; border-top:none; border-bottom:none; font-size:15px;"></td>
                </tr>
              `);
            }
            return renderedRows.join("");
          })()}
        </tbody>
        <tfoot>
          <tr>
            <td colspan="2" style="border:1px solid #000;border-left:none;  border-bottom:none; font-weight:bold; text-align:right; padding:8px 4px; font-size:15px; height:35px;">JUMLAH PERLU DIBAYAR (RM)</td>
            <td style="border:1px solid #000; font-weight:bold; text-align:right; padding:8px 4px; font-size:15px;">
              ${(() => {
                const jumlahPerkara =
                  selected.jumlah !== undefined && selected.jumlah !== null
                    ? parseFloat(selected.jumlah)
                    : 0;
                const tunggakan =
                  selected.tunggakan_to_date !== undefined &&
                  selected.tunggakan_to_date !== null
                    ? parseFloat(selected.tunggakan_to_date)
                    : 0;
                const denda =
                  selected.denda_to_date !== undefined && selected.denda_to_date !== null
                    ? parseFloat(selected.denda_to_date)
                    : 0;
                const total = (parseFloat(selected.jumlah || 0) + parseFloat(selected.tunggakan_to_date || 0) + parseFloat(selected.denda_to_date || 0));
                return total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              })()}
            </td>
          </tr>
        </tfoot>
      </table>
      <div style="display:flex; flex-direction:row; justify-content:space-between; align-items:flex-start; margin-top:50px;">
        <div style="font-size:12px; text-align:left; flex:1;">SILA BAYAR SEBELUM ATAU PADA 7HB SETIAP BULAN</div>
        <div style="flex:1; text-align:right;">
          <div style="font-size:12px; text-align:right; margin-bottom:10px;">Sila imbas QR Kod ini untuk bayaran secara on-line</div>
          <div style="display:flex; flex-direction:row; align-items:center; justify-content:flex-end; gap:1px; height:150px;"> 
            <div style="display:flex; flex-direction:column; align-items:center; justify-content:center; height:100%; min-width:110px; max-width:130px; border-radius:8px; padding-right:8px;">
              <img src="/build/senangpay.png" style="height:40px; width:auto; margin-bottom:10px; display:block;" />
              <div style="display:flex; flex-direction:row; align-items:center; justify-content:center; gap:2px;">
                <img src="/build/visa.webp" style="height:10px; width:auto;" />
                <img src="/build/mastercard.png" style="height:20px; width:auto;" />
                <img src="/build/fpx.png" style="height:20px; width:auto;" />
              </div>
            </div>
            <img src="${(() => {
              try {
                // Inline placeholder replaced post-template. This will be substituted before writing.
                return "__QR_DATA_URL__";
              } catch (e) {
                return "/build/qr.png";
              }
            })()}" style="height:150px; width:150px; background:#fff;" />
          </div>
        </div>
      </div>
      <div class="footer-note">
        (Inbois ini adalah cetakan komputer dan tidak memerlukan tandatangan)
      </div>
      <script>
        function imagesLoaded(doc, callback) {
          var imgs = doc.images;
          if (!imgs || imgs.length === 0) return callback();
          var loaded = 0;
          var check = function() { if (++loaded >= imgs.length) callback(); };
          for (var i = 0; i < imgs.length; i++) {
            if (imgs[i].complete) check();
            else imgs[i].addEventListener('load', check, false);
            imgs[i].addEventListener('error', check, false);
          }
        }
        imagesLoaded(document, function() { window.print(); });
      </script>
    </body>
    </html>
  `;
  // Build QR target URL and generate data URL
  let qrDataUrl = "/build/qr.png";
  try {
    // Prefer a public base URL for mobile scanning (set REACT_APP_PUBLIC_BASE_URL in .env)
    const publicBase = (process.env.REACT_APP_PUBLIC_BASE_URL || window.location.origin).replace(/\/$/, "");
    const targetUrl = `${publicBase}/qr/${encodeURIComponent(selected.no_akaun || "")}`;
    qrDataUrl = await QRCode.toDataURL(targetUrl, { width: 150, margin: 1 });
  } catch (_) {
    // keep fallback
  }
  // Inject the generated QR data URL into the HTML
  const htmlWithQr = printHtml.replace("__QR_DATA_URL__", qrDataUrl);
  printWindow.document.write(htmlWithQr);
  printWindow.document.close();
}

export default printInboisPreview;
